import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {memoize} from 'decko';
import {saveAs} from 'file-saver/FileSaver';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';

import {DataChangesObserver, TitleService} from '@common-lib';
import {ConfigurationService, ProductsService, CategoriesService} from '../../pages-services';
import {ConfigurationBaseComponent} from '../configuration-base/configuration-base.component';

@Component({
    selector: 'app-configuration-navigation',
    templateUrl: './configuration-navigation.component.html',
    styleUrls: ['../configuration-base/configuration-base.component.scss', '../configuration-navigation/configuration-navigation.component.scss'],
})

export class ConfigurationNavigationComponent extends ConfigurationBaseComponent implements OnInit {
    resource = 'navigation';

    navigations = [];
    categories = [];
    products = [];
    productsById = [];

    constructor(
        protected title: TitleService,
        protected route: ActivatedRoute,
        protected toasterService: ToasterService,
        protected dataChanges: DataChangesObserver,
        protected translateService: TranslateService,
        protected configurationService: ConfigurationService,
        private productsService: ProductsService,
        private categoriesService: CategoriesService
    ) {
        super(title, route, toasterService, dataChanges, translateService, configurationService);
    }

    ngOnInit() {
        this.productsService.getList(this.selectedLocale).subscribe(({products}) => {
            products.forEach(product => {
                const {id, title} = product;
                this.productsById[id] = title;
            });
            this.products = products;
        });

        this.categoriesService.getList(this.selectedLocale).subscribe(({categories}) => this.categories = categories);

        this.loadItems();
    }

    protected loadItems(): Promise<Object> {
        const resource = 'navigations';
        return new Promise((resolve, reject) => {
            this.configurationService.getList(resource, this.selectedLocale).subscribe(({result}) => {
                this.state.items = this.createChangesObservation(result);
                // console.log('result: ', result);
                resolve(this.state.items);
            }, error => reject(error));
        });
    }

    @memoize()
    getDropdownList(productId) {
        return this.categories.filter(item => item.productId === productId || !item.productId);
    }

    dropdawnOnAdd(event, productId) {
        const {id} = event;
        this.categories.forEach(item => {
            if (item.id === id) {
                item.productId = productId;
            }
        });
    }

    dropdawnOnRemove(event) {
        const {id} = event.value;
        this.categories.forEach(item => {
            if (item.id === id) {
                delete item.productId;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/configuration-navigation/configuration-navigation.component.ts